



































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";
import VAccordion from "@/components/VAccordion.vue";
import ScoutingPlaceItem from "@/components/ScoutingPlace/Item.vue";
import IsocronCable from "@/cables/isocronCable";
import ModelParserMixin from "@/mixins/ModelParser";
import PoiSearch from "@/components/ScoutingPlace/Search.vue";
import IsocronCollapsible from "@/components/Isocron/Collapsible.vue";
import { ScoutingPlace } from "@/models";
import { AnalysisState } from "@/models/Scouting";

@Component({
  components: {
    VAccordion,
    ScoutingPlaceItem,
    PoiSearch,
    IsocronCollapsible,
  },
})
export default class ScoutingPlaceCollapsableList extends Mixins(
  ModelParserMixin
) {
  @Prop({ default: false }) readonly showLegend!: boolean;
  @Prop({ default: false }) readonly isOpened!: boolean;

  private importer: IsocronCable | null = null;

  private term = "";

  async load() {
    await currentScoutingStore.loadScoutingPlaces();
  }

  get scoutingPlaces() {
    return currentScoutingStore.scoutingAnalysis?.scouting.scoutingPlaces || [];
  }

  mounted() {}

  onStatusChanged(closed: boolean) {
    this.$emit("status", closed);
  }

  get poiCount() {
    return this.scoutingPlaces.length;
  }

  async onScoutingPlaceClicked(item: ScoutingPlace) {
    await currentScoutingStore.clearSelection();
    await currentScoutingStore.changeScoutingAnalysisState(AnalysisState.POI);
    await currentScoutingStore.changeScoutingAnalysisCurrentPlace(item);
  }
}
